import differenceWith from 'lodash/differenceWith';
import union from 'lodash/union';

import { useFeatureFlag } from '@/utils/hooks';
import {
    ADD_MEDIAS,
    REMOVE_ALL_MEDIA,
    useAlbumContext
} from '@/utils/hooks/context/useAlbumContext';
import useTranslation from '@/utils/hooks/translation/useTranslation';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import { TWITTER } from '@/lib/socialProfile';
import { ALBUM_LIMIT } from '@/components/pages/albums/AlbumFunnelModal/constants/albumLimit';

import Icon from '@/components/base/Icon';

const MediaSelectionSection = ({ dataMedias }) => {
    const { t } = useTranslation('content');
    const { albumInfo, dispatch } = useAlbumContext();
    const { activeSocialProfile } = useActiveSocialProfile();
    const network = activeSocialProfile?.social_network_type;
    const typePost = albumInfo?.criteria?.album_type === 'stories' ? 'stories' : 'medias';
    const campaignFeatureFlagEnabled = useFeatureFlag('campaign_media_limit_500_active');
    let allVisibleMedias = [];

    dataMedias?.map((medias) => {
        let allMedias = medias?.[typePost]?.map((media) => ({
            id: media?.id,
            social_profile_id: media?.social_profile_id || activeSocialProfile?.id
        }));
        if (campaignFeatureFlagEnabled) {
            allVisibleMedias = [...new Set([...allVisibleMedias, ...allMedias])].slice(
                0,
                ALBUM_LIMIT
            );
        } else {
            allVisibleMedias = union(allVisibleMedias, allMedias);
        }
    });
    return (
        <div className="flex flex-wrap justify-between gap-3">
            <div className="flex space-x-2 px-2 text-sm">
                <Icon icon="albums" className="text-icoBlue" />
                <span>
                    {network === TWITTER ? t('modal.selected_tweets') : t('modal.selected_medias')}:
                </span>
                {campaignFeatureFlagEnabled ? (
                    <span>
                        <span className="text-icoBlue">
                            {albumInfo?.medias?.length < ALBUM_LIMIT
                                ? albumInfo?.medias?.length
                                : ALBUM_LIMIT}
                        </span>
                        /{ALBUM_LIMIT}
                    </span>
                ) : (
                    <span className="text-icoBlue">{albumInfo?.medias?.length ?? 0}</span>
                )}
            </div>
            <div className="space-x-5 text-xs text-icoBlue">
                {albumInfo?.medias?.length ? (
                    <button onClick={() => dispatch({ type: REMOVE_ALL_MEDIA })}>
                        {t('modal.edit_modal.unselect_all_posts')}
                    </button>
                ) : null}
                {dataMedias &&
                dataMedias?.[0]?.[typePost]?.length &&
                differenceWith(allVisibleMedias, albumInfo?.medias, (visible, selected) => {
                    return visible.id === selected.id;
                }).length ? (
                    <button
                        onClick={() =>
                            dispatch({
                                type: ADD_MEDIAS,
                                payload: allVisibleMedias
                            })
                        }>
                        {t('modal.select_all_visible_posts')}
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default MediaSelectionSection;
